import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';


export const getWebSettings = async () => {
  try {
    const response = await Axios.get(`/web_settings/store`);

    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetWebSettings = () => {
  const webSettings = useQuery({
    queryKey: ['get_all_web_settings'],
    queryFn: () => getWebSettings(),
  });

  return webSettings;
};
